import React from "react";

import {
  PrimaryBlockType,
  primaryBlock,
  PrimaryBlockConfig,
  SecondaryBlockSize,
  TertiaryBlockSize,
  BlockTheme,
  renderSecondaryBlock,
  getDefaultProps,
  BlockType,
  MediaProp,
} from "@kameleon-core/lib";
import { Box } from "theme-ui";
import { Variants } from "@kameleon-util/global-theme";
import { LayoutProps } from "../types/prop-types";
import defaults from "../defaults.json";

export type ContentCollectionItemType = {
  /** Place prop documentation here */
  header: string;
  text: string;
  image: MediaProp;
} & PrimaryBlockType<LayoutProps>;

/** ContentCollectionItem PrimaryCollection */
export const blockConfig: PrimaryBlockConfig = {
  secondaryBlockSize: SecondaryBlockSize.Medium,
  tertiaryBlockSize: TertiaryBlockSize.None,
  blockTheme: BlockTheme.light,
  blockType: BlockType.PrimaryCollection,
};

export const ContentCollectionItem = primaryBlock<ContentCollectionItemType>(
  { isInnerBlock: true, ...blockConfig },
  ({ SecondaryBlock, header, text }: ContentCollectionItemType) => (
    <Variants.LinkText
      sx={{ fontWeight: "normal" }}
      className="primary-collection-content-collection-two-col-tab-headers-v1"
    >
      <Box>
        <Variants.LinkTabHeading>
          <Variants.Heading as="h3" variant="h4">
            {header}
          </Variants.Heading>
        </Variants.LinkTabHeading>
        <Box className="tabs-link__content">
          <Variants.ParagraphDefault>{text}</Variants.ParagraphDefault>
          {renderSecondaryBlock(SecondaryBlock)}
        </Box>
      </Box>
    </Variants.LinkText>
  )
);

const itemDefaults = {
  layoutProps: defaults.layoutProps,
  contentProps: defaults.contentProps.PrimaryBlocks[0] ?? {},
};
ContentCollectionItem.defaultProps =
  getDefaultProps<ContentCollectionItemType>(itemDefaults);
